<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-tabs>
          <v-tab>Common</v-tab>
          <v-tab-item>
            <v-sheet class="px-3" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
              <BaseFieldString
                  v-model="storeAggregate.rootData[storeDetail.uidItem].name"
                  label="Name"
                  class="mt-3"
              ></BaseFieldString>
              <BaseFieldString
                  v-model="storeAggregate.rootData[storeDetail.uidItem].alias"
                  label="Client ID"
                  class="mt-3"
              ></BaseFieldString>
              <v-checkbox
                  v-model="storeAggregate.rootData[storeDetail.uidItem].is_provider"
                  label="Provider"
                  class="mt-3"
              ></v-checkbox>
              <v-checkbox
                  v-model="storeAggregate.rootData[storeDetail.uidItem].is_customer"
                  label="Customer"
                  class="mt-3"
              ></v-checkbox>
              <v-checkbox
                  v-model="storeAggregate.rootData[storeDetail.uidItem].is_material_owner"
                  label="Material owner"
                  class="mt-3"
              ></v-checkbox>
            </v-sheet>
          </v-tab-item>
          <v-tab>Material delivery</v-tab>
          <v-tab-item>
            <v-sheet class="px-3" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
              <MaterialDeliveryTable
                  :store-name="storeMaterialDeliveryTableName"
                  :height="componentHeight - 210"
              >
                <template v-slot:footer.prepend>{{ '' }}</template>
              </MaterialDeliveryTable>
            </v-sheet>
          </v-tab-item>
        </v-tabs>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import {v4 as uuidv4} from "uuid";
import {useTableStore} from "@/components/Common/CommonTable";
import MaterialDeliveryTable from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryTable";

export default {
  name: "ClientDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'ClientDetail'},
    dtoDetailQuery: {default: 'ClientDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ClientActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ClientSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ClientValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ClientBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'ClientTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldCheck,
    BaseFieldString,
    CommonDetail,
    MaterialDeliveryTable,
  },

  computed: {
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    componentHeight() {
      if (this.modalDialog) {
        return this.$vuetify.breakpoint.height * 0.90 - 39
      } else {
        return this.$vuetify.breakpoint.height - 39
      }
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.filterQueryMaterialDeliveryTable()
      },
      deep: true
    },
  },

  methods: {
    filterQueryMaterialDeliveryTable() {
      this.storeMaterialDeliveryTable.query_filters = {
        and_concat: false,
        filter_list: [
          {param_compare: 'provider__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },
  }
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    this.storeMaterialDeliveryTable = useTableStore(this.storeMaterialDeliveryTableName)()
    this.filterQueryMaterialDeliveryTable()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeMaterialDeliveryTable: null,
      storeMaterialDeliveryTableName: uuidv4(),
    }
  }
  ,
}
</script>

<style scoped>

</style>